// extracted by mini-css-extract-plugin
export var explainable = "_jv-a";
export var printerCard = "_jv-1";
export var printerCardConfigured = "_jv-2";
export var printerCardError = "_jv-3";
export var printerCardsContainer = "_jv-0";
export var printerIcon = "_jv-8";
export var printerIconConfigured = "_jv-5";
export var printerIconContainer = "_jv-4";
export var printerIconError = "_jv-6";
export var printerIconUnconfigured = "_jv-7";
export var workstationsTableCard = "_jv-9";